class SBTabs {
  constructor(element) {
    if (!element) return;

    this.container = element;
    this.tabButtons = this.container.querySelectorAll('[data-tab-button]');
    this.tabPanels = this.container.querySelectorAll('[data-tab-panel]');

    if (this.tabButtons.length === 0) return;

    this.bindEvents();
  }

  bindEvents() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (event) => this.onTabClick(event));
    });
  }

  onTabClick(event) {
    const clickedButton = event.currentTarget;

    // Deactivate all buttons and panels within this specific component
    this.tabButtons.forEach(btn => btn.classList.remove('active'));
    this.tabPanels.forEach(panel => panel.classList.remove('active'));

    // Activate the clicked button
    clickedButton.classList.add('active');

    // Activate the corresponding panel
    const targetPanel = this.container.querySelector(clickedButton.dataset.target);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  }
}

// Initialize all tab components on the page
document.addEventListener('DOMContentLoaded', () => {
  const tabComponents = document.querySelectorAll('[data-component="sb-tabs"]');
  tabComponents.forEach(component => {
    new SBTabs(component);
  });
});